import { useCallback } from 'react';
import { Toast } from 'antd-mobile';

export const useCustomToast = () => {
    const showToast = useCallback((icon: 'success' | 'fail' | 'loading', content: string, position:  'top' | 'bottom' | 'center') => {
        Toast.show({
            icon,
            content,
            position
        });
    }, []);

    return { showToast };
};

export const useNoIconToast = () => {
    const showNoIconToast = useCallback((content: string, position:  'top' | 'bottom' | 'center') => {
        Toast.show({
            content,
            position
        });
    }, []);

    return { showNoIconToast };
};
